<!--首页-->
<template>
  <div>
    <div class="box">
      <!--<div class="active-search">-->
      <!--<div class="search-box">-->
      <!--<img class src='../../assets/images/icon-index-search.png'/>-->
      <!--<span class="active-search-name">搜索项目/单位/队伍</span>-->
      <!--</div>-->
      <!--</div>-->
      <div
        style="margin-bottom: 20px; border-bottom: 1px solid #00000010; padding-bottom: 10px"
        class="active-item"
        v-for="(item,index) in row.doing"
        v-rblink="{name:'ISaiApplyFormStep1','query':{ 'saiqu_id':item.id }}"
        :key="index"
      >
        <p class="active-item-name">{{item.name}}</p>
        <div class="active-item-info">
          <img :src="item.pic_url" alt srcset />
          <span class="info-top-left">正在进行</span>
          <div class="info-bottom">
            <div class="left">
              <span>{{item.member_count}}人参加</span>
            </div>
            <div class="right">
              <span>{{item.saidate_str}}</span>
              <span>{{item.province}} {{item.city}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="row.doing.length==0">
        <van-empty description="暂无活动" />
      </div>
      <div style="width:7rem;margin:0 auto;margin-top:20px" v-if="row.going.length>0">
        <div class="in-active-start">即将开始</div>
        <div class="active-start" v-for="(item,index) in row.going" :key="index">
          <div class="left">
            <img src="../../assets/images/pic-active-pic2.png" alt srcset />
            <div class="bottom">
              <span>2020-12-01</span>
              <span>中国·南京</span>
            </div>
          </div>

          <div class="right">
            <p class="start-item-title">2019-2020年全国啦啦操联赛（上海闵行站）</p>
            <div class="start-time">
              <img src="../../assets/images/icon-time.png" alt srcset />
              <span>2天21：27：12开始</span>
            </div>
            <div style="display:flex;justify-content:space-around">
              <span class="into">进入</span>
              <span class="join">报名</span>
            </div>
          </div>
        </div>
      </div>

      <div class="more-box" v-if="row.pass.length>0" style="display: none">
        <div class="more-active">
          <div style="display:flex;align-items: center">
            <div class="solid"></div>
            <span class="more-title">往期活动</span>
          </div>
          <div style="display:flex;align-items: center" v-rblink="{name:'SaiDateList',query:{}}">
            <div class="more-right">更多</div>
            <img src="../../assets/images/arrow.png" alt srcset />
          </div>
        </div>
        <div style="display:flex;justify-content:space-between">
          <div
            v-rblink="{name:'ActivityActivity','query':{id:item.activity_id}}"
            class="more-active-address address-box1"
            v-for="(item,index) in row.pass"
            :key="index"
          >
            <p class="address-box-top"></p>
            <p class="address-box-main">{{item.city}}</p>
            <p class="address-box-bottom">{{item.saidate_str}}</p>
          </div>
        </div>
      </div>

      <!-- 底部导航 -->
      <TabBar :show-tab-bar="showTabBar"></TabBar>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.address-box-top {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #fff;
}
.address-box-main {
  font-size: 35px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #fff;
}
.address-box-bottom {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #fff;
}
.more-active-address {
  width: 2.8rem;
  height: 2.08rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-left: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.address-box1 {
  background-image: linear-gradient(to right, #01ea9b, #8dec9d);
}
.address-box2 {
  background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
}
.more-box {
  width: 6.25rem;
  background: #fff;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
}
.more-active {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.more-active .solid {
  width: 4px;
  height: 25px;
  border-radius: 4px;
  background-image: linear-gradient(#1eb2ff, #2b7aff);
  margin-right: 5px;
}
.more-active .more-title {
  color: #333;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}
.more-active .more-right {
  color: #333;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.more-active img {
  margin-left: 5px;
  width: 5.5px;
  height: 10px;
}

.start-item-title {
  color: #333;
  font-size: 16px;
}
.in-active-start {
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.start-time {
  display: flex;
  align-items: center;
}
.start-time span {
  color: #333;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
}
.start-time img {
  width: 12.5px;
  height: 12.5px;
  margin-right: 5px;
}
.active-start .into {
  height: 26px;
  width: 42%;
  background: #e63737;
  border-radius: 26px;
  border: 1px solid #e63737;
  text-align: center;
  line-height: 26px;
  color: #fff;
}
.active-start .join {
  height: 26px;
  width: 42%;
  background: #fff;
  border-radius: 26px;
  border: 1px solid #e63737;
  text-align: center;
  line-height: 26px;
  color: #e63737;
}

.active-start {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
/* .active-start .left,.active-start .right{width: 50%;} */
.active-start .left {
  position: relative;
  width: 3.15rem;
  height: 2rem;
  overflow: hidden;
  border-radius: 10px;
}
.active-start .right {
  flex: 1;
  overflow: hidden;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.active-start .left img {
  height: 100%;
}
.active-start .left .bottom {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(113, 112, 113, 0.8);
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #fff;
}
.bottom-time-address {
  display: flex;
  justify-content: space-around;
}
.active-item {
  width: 7rem;
  margin: 0 auto;
  margin-top: 10px;
}
.active-item-name {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: "#333";
}
.active-item-info {
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 5px;
  position: relative;
}
.active-item-info img {
  width: 100%;
  display: block;
}
.info-top-left {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0 5px;
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  display: block;
  background-image: linear-gradient(to right, #ff9535, #f5a625);
  border-radius: 20px;
}
.info-bottom {
  width: 100%;
  height: 25px;
  display: flex;
  background: rgba(113, 112, 113, 0.8);
  position: absolute;
  bottom: 0;
  line-height: 25px;
}
.info-bottom .left,
.info-bottom .right {
  width: 50%;
}
.info-bottom .left span {
  margin-left: 10px;
}
.info-bottom .right {
  display: flex;
  justify-content: space-around;
}
.info-bottom span {
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
}
.active-search-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(186, 186, 186, 1);
}
.search-box img {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 3px;
}
.active-search {
  width: 100%;
  height: 1.2rem;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}
.search-box {
  width: 7rem;
  height: 0.6rem;
  background: rgba(239, 239, 244, 1);
  border-radius: 5px;
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box {
  background: #f8f8f8;
  margin-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";

export default {
  name: "Activity",
  components: {
    TabBar,
    LoginDialog
  },
  data: function() {
    return {
      loginShow: false,
      showTabBar: false,
      row: {
        doing: [],
        going: [],
        pass: []
      }
    };
  },
  filter: {},
  mounted() {
    document.title = "活动";
    let that = this;
    this.showTabBar = window.isApp() ? false : true;
    this.fetch();

    window.rbMessage = function(data) {
      if (data == "logout") {
        localStorage.setItem("_pspt", null);
        localStorage.setItem("_token", null);
        that.fetch();
      } else {
        data = JSON.parse(data);
        if (data[0] == "login") {
          //						alert(data[2]);
          localStorage.setItem("_pspt", data[1]);
          localStorage.setItem("_token", data[1]);
          localStorage.setItem("_phone", data[2]);
          that.fetch();
        }
      }
    };
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      this.$api.get(
        "/api/activity/indexData",
        {},
        res => {
          console.log(res);
          that.row = res.data;
        },
        res => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// Activity.vue?9283670a